module.exports = __webpack_public_path__ + "img/item-1.b218a95.png";